// @ts-nocheck
import React from 'react';
import { Row, Col, Form, Divider, Select, Input } from 'antd';
import { Tooltip } from 'antd';
import { TextField, ButtonsComponent, CheckBoxField, CKEditorField, InputValuesObject } from '../../look';
import ChoiceFormComponent from './ChoiceFormComponent';
import AnswerFormComponent from './AnswerFormComponent';

export const CKEditorFieldName = 'helpText';
export const CKEditorFieldName1 = 'questionText';

const QuestionFormComponent = props => {
  const { onSubmit, questionById } = props;
  const [choices, setChoices] = React.useState([]);
  const [button, setButton] = React.useState('');

  React.useEffect(() => {
    if (questionById && questionById.choiceSet) {
      const choice = questionById.choiceSet.edges.map(({ node }) => ({
        id: node.id,
        label: node.label,
        value: node.value,
        sequence: node.sequence,
        inputType: node.inputType.toLowerCase(),
        graphic: node.graphic,
        answerKey: node?.answerKey ?? false,
        answerSet: (node?.answerSet && JSON.parse(node.answerSet)) || []
      }));
      setChoices(choice);
    }
  }, [questionById]);

  const initialValue = {
    questionText: questionById?.questionText,
    helpText: questionById?.helpText,
    sequence: questionById?.sequence,
    required: questionById?.required,
    mediaType: questionById?.mediaType,
    mediaUrl: questionById?.url,
  };

  let non_subjective_question_type = [
    InputValuesObject.checkbox,
    InputValuesObject.color,
    InputValuesObject.file,
    InputValuesObject.radio,
    InputValuesObject.range,
    InputValuesObject.select,
  ]

  function extractPlainText(html) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');
    return doc.body.textContent?.replace(/\u00A0/g, ' ').trim() || '';
  }

  const handleSubmit = values => {
    const data = {
      questionText: values.questionText,
      helpText: values.helpText,
      sequence: Number(values.sequence),
      required: Boolean(values.required),
      mediaType: values.mediaType,
      url: values.mediaUrl,
    };

    const updatedChoices = choices.length !== 1 || choices[0].value !== "para_question"
      ? choices
      : [{ ...choices[0], label: extractPlainText(choices?.[0]?.label) }]
    setChoices(prev => updatedChoices)
    onSubmit(data, choices, button);
  };

  return (
    <Row>
      <Col span={24}>
        <Form
          layout="vertical"
          onFinish={handleSubmit}
          initialValues={initialValue}
          scrollToFirstError={true}
        >
          <Row align="middle">
            <Col span={22} offset={1}>
              <CKEditorField
                name={CKEditorFieldName1}
                label="Name"
                initialValue={initialValue.questionText}
                rules={[{ required: true, message: 'Name is required!' }]}
              />
            </Col>

            <Col span={10} offset={1}>
              <Row>
                <Col lg={14} md={20}>
                  <TextField
                    name="sequence"
                    label="Sequence"
                    type="number"
                    rules={[{ required: true, message: 'Sequence is required!' }]}
                  />
                </Col>
              </Row>
            </Col>

            <Col lg={10} md={13} xs={24}>
              <Row align="middle">
                <Col lg={14} md={20}>
                  <CheckBoxField name="required" label="Required" />
                </Col>
              </Row>
            </Col>

            <Col lg={3} md={0} xs={0} />
            <Col span={22} offset={1}>
              <CKEditorField
                name={CKEditorFieldName}
                label="Help Text"
                initialValue={initialValue.helpText}
              />
            </Col>

            <Col span={22} offset={1}>
              <Row gutter={16}>
                {/* Media Type Field */}
                <Col lg={12} md={12} xs={24}>
                  <Form.Item name="mediaType" label="Media Type">
                    <Select placeholder="Select media type">
                      <Select.Option value="audio">Audio</Select.Option>
                      <Select.Option value="video">Video</Select.Option>
                    </Select>
                  </Form.Item>
                </Col>

                {/* Media URL Field with disabled logic + tooltip */}
                <Col lg={12} md={12} xs={24}>
                  <Form.Item
                    noStyle
                    shouldUpdate={(prev, curr) => prev.mediaType !== curr.mediaType}
                  >
                    {({ getFieldValue }) => {
                      const mediaType = getFieldValue('mediaType');
                      const isDisabled = !mediaType;

                      return (
                        <Tooltip
                          title="Only for media-type questions"
                          placement="topLeft"
                        >
                          <Form.Item
                            name="mediaUrl"
                            label="Media URL"
                            rules={[
                              {
                                required: !!mediaType,
                                message: 'Media URL is required when Media Type is selected.',
                              },
                            ]}
                          >
                            <Input
                              placeholder="Enter media URL"
                              disabled={isDisabled}
                            />
                          </Form.Item>
                        </Tooltip>
                      );
                    }}
                  </Form.Item>
                </Col>
              </Row>
            </Col>

          </Row>

          <Divider />
          <ChoiceFormComponent choices={choices} setChoices={setChoices} />
          <Divider />
          {
            (
              (choices?.length && choices?.every(choice => (choice?.answerSet === null || choice?.answerSet?.length === 0) !== true))
              || !non_subjective_question_type.includes(choices?.[0]?.inputType?.toUpperCase() || '')
            )
            && <>
              <AnswerFormComponent choices={choices} setChoices={setChoices} />
            </>
          }
          <ButtonsComponent setButton={setButton} />
        </Form>
      </Col>
    </Row>
  );
};

export default QuestionFormComponent;
